<template>
  <div class="page">
	<!---->
	<div class="authorizationWrapper">
		<topheader back="/signin"/>
		<div class="brandWrapper">
			<logotype :big="true"/>
		</div>
	  	<authorization />
	</div>
  </div>
</template>

<style scoped lang="sass">

	.page
		background: transparent
		
	.authorizationWrapper
		max-width: 540px
		margin: 0 auto
		border-radius: 6px
		padding: 4 * $r

	.brandWrapper
		margin-bottom: 4 * $r

		::v-deep
			.logo
				img
					height: 84px

	::v-deep
		#topheader 
			background: transparent
			.headerLine
				padding-left: 0
				.iconbutton 
					padding-left: 0.5 * $r
					text-align: left

	@media only screen and (max-width: 768px)
		.brandWrapper
			padding-left: 0
			margin-top : 4 * $r
			margin-bottom: 4 * $r
			display: block

		.authorizationWrapper
			max-width: none
			border : 0
			padding: 2 * $r

</style>

<script>
import authorization from "@/components/common/authorization/index.vue";

export default {
  name: "authorization_page",
  components: {
	authorization,
  },

  computed: {},

  methods: {},

  mounted() {},
};
</script>
